import { useDispatch } from "react-redux";
import { addToCart } from "../redux/cart/actions";
import { decreaseProductQuantity } from "../redux/product/actions";

export default function ProductCard({ item }) {
    const dispatch = useDispatch();

    const addToCartHandler = () => {
        dispatch(addToCart(item.id));
        dispatch(decreaseProductQuantity(item.id));
    }
    
    const disableAddToCart = item.quantity <= 0;

    return (
        <div className="lws-productCard">
            <img
                className="lws-productImage"
                src={item.imageUrl}
                alt="product"
            />
            <div className="p-4 space-y-2">
                <h4 className="lws-productName">{item.name}</h4>
                <p className="lws-productCategory">{item.category}</p>
                <div className="flex items-center justify-between pb-2">
                    <p className="productPrice">
                        BDT <span className="lws-price">{item.price}</span>
                    </p>
                    <p className="productQuantity">
                        QTY <span className="lws-quantity">{item.quantity}</span>
                    </p>
                </div>
                <button disabled={disableAddToCart} onClick={addToCartHandler} className="lws-btnAddToCart">Add To Cart</button>
            </div>
        </div>
    );
}
